import { Sku } from './types';

export default function useProductPriceLogic(sku: Sku) {
  const onSale = !!sku.sale_price;
  const showMsrp = sku.msrp > 0 && sku.msrp > sku.price;
  const showSavings = showMsrp || onSale;

  return {
    onSale,
    showMsrp,
    showSavings,
  };
}
